import { css } from '@emotion/css';
import { primary, N50 } from '@/colors/colorsV1';

export const styProgressBarOuter = ({ height }) => css`
  width: calc(100% - ${height}px);
  height: ${height}px;
  background-color: ${N50};
  border-radius: ${`${height / 2}px`};
`;

export const styProgressBarInner = ({ height, width, color }) => css`
  width: ${width}%;
  height: ${height}px;
  background-color: ${color};
  border-radius: ${`${height / 2}px`};
  transition: width 1s ease-out;
`;

export const styLabelContainer = css`
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  > span {
    color: ${primary};
    font-size: 10px;
  }
`;
